var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.showCreateNoteModal}},[_vm._v(" "+_vm._s(_vm.$t('contact_notes.create'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }